export interface MessageHistoryParticipant {
  platformUserId?: string;
  name: string;
  email?: string | null;
  phone?: string | null;
}

export interface MessageHistoryItem {
  messageId: string;
  hotelId: string;
  requestId: string | null;
  type: string;
  sender: MessageHistoryParticipant;
  receiver: MessageHistoryParticipant | null;
  subject: string | null;
  content: string;
  createdAt: string;
}

export interface MessageHistoryMeta {
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
}

export interface MessageHistoryResponse {
  data: MessageHistoryItem[];
  meta: MessageHistoryMeta;
}

export interface MessageHistoryParams {
  page?: number;
  limit?: number;
  type?: string;
  search?: string;
  senderPlatformUserId?: string;
  receiverPlatformUserId?: string;
  requestId?: string;
}

export const createMessageHistoryApi = (callApi: (config: any) => Promise<any>) => {
  return {
    async fetchMessages(
      params: MessageHistoryParams = {}
    ): Promise<MessageHistoryResponse> {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.type) queryParams.append("type", params.type);
      if (params.search) queryParams.append("search", params.search);
      if (params.senderPlatformUserId) {
        queryParams.append("senderPlatformUserId", params.senderPlatformUserId);
      }
      if (params.receiverPlatformUserId) {
        queryParams.append("receiverPlatformUserId", params.receiverPlatformUserId);
      }
      if (params.requestId) queryParams.append("requestId", params.requestId);

      const url = queryParams.toString()
        ? `/management/messages?${queryParams.toString()}`
        : "/management/messages";

      const response = await callApi({
        method: "GET",
        url,
      });

      return response.data;
    },
  };
};

export type MessageHistoryApi = ReturnType<typeof createMessageHistoryApi>;
